export class ConfiguracoesEntity {
  bancoCaixaId = null;
  jurosPorcentagem = null;
  multaPorcentagem = null;
  carencia = null;
  obrigatoriedadeCnpjCpf = null;
  obrigatoriedadeMeioPagamento = null;
  vendaEstoqueNegativo = null;
  margemCalculo = "INVERSA";
  precificacaoNfEntrada = null;
  operacaoFiscalPdvPadraoId = null;
  operacaoFiscalPdvSecundariaId = null;
  impressaoDiretaPdv = false;
  operacaoFiscalComprasPadraoId = null;
  cfopComprasPadraoId = null;
  operacaoFiscalVendasPadraoId = null;
  operacaoFiscalMdfePadraoId = null;
  meioPagamentoInicial = null;
  pagamentosPadroes = [];
  visualizarImpressaoEmissao = null;
  diasVencimentoOrcamento = null;
  limiteCredito = null;
  inadimplencia = null;
  descontoVendaItem = null;
  despesaVendaItem = null;
  freteVendaItem = null;
  zerarSaldoAnteriorCaixa = null;
  utilizarSuprimentoSangria = null;
  exibirDescricaoServico = null;
  lembreteAntecedenciaServico = null;
  buscaProdutosCodigoBarras = null;
  impressoraEtiqueta = null;
  impressoraTermica = null;
  impressaoDiretaOrcamentos = null;
  impressaoDiretaPedidos = null;
  impressaoDiretaNf = null;
  modeloImpressaoPadraoNf = null;
  modeloImpressaoPadraoCondicionais = null;
  modeloImpressaoPadraoOrcamentos = null;
  modeloImpressaoPadraoPedidos = null;
  confirmacaoImpressaoOrcamentos = null;
  confirmacaoImpressaoPedidos = null;
  confirmacaoImpressaoNf = null;
  confirmacaoImpressaoPdv = null;
  modalidadeComissao = null;
  vendedorPorItemServico = null;

  constructor(configuracoes) {
    this.bancoCaixaId = configuracoes.bancoCaixaId;
    this.jurosPorcentagem = configuracoes.jurosPorcentagem;
    this.multaPorcentagem = configuracoes.multaPorcentagem;
    this.carencia = configuracoes.carencia;
    this.obrigatoriedadeCnpjCpf = configuracoes.obrigatoriedadeCnpjCpf;
    this.obrigatoriedadeMeioPagamento =
      configuracoes.obrigatoriedadeMeioPagamento;
    this.vendaEstoqueNegativo = configuracoes.vendaEstoqueNegativo;
    this.precificacaoNfEntrada = configuracoes.precificacaoNfEntrada;
    this.operacaoFiscalPdvPadraoId = configuracoes.operacaoFiscalPdvPadraoId;
    this.impressaoDiretaPdv = configuracoes.impressaoDiretaPdv || false;
    this.operacaoFiscalPdvSecundariaId =
      configuracoes.operacaoFiscalPdvSecundariaId;
    this.operacaoFiscalComprasPadraoId =
      configuracoes.operacaoFiscalComprasPadraoId;
    this.cfopComprasPadraoId = configuracoes.cfopComprasPadraoId;
    this.operacaoFiscalVendasPadraoId =
      configuracoes.operacaoFiscalVendasPadraoId;
    this.operacaoFiscalMdfePadraoId = configuracoes.operacaoFiscalMdfePadraoId;
    this.meioPagamentoInicial = configuracoes.meioPagamentoInicial;
    this.modalidadeComissao = configuracoes.modalidadeComissao;
    if (configuracoes.margemCalculo) {
      this.margemCalculo = configuracoes.margemCalculo;
    }
    this.visualizarImpressaoEmissao = configuracoes.visualizarImpressaoEmissao;
    this.diasVencimentoOrcamento = configuracoes.diasVencimentoOrcamento;
    this.limiteCredito = configuracoes.limiteCredito || "AVISAR";
    this.inadimplencia = configuracoes.inadimplencia || "AVISAR";
    this.descontoVendaItem = configuracoes.descontoVendaItem;
    this.despesaVendaItem = configuracoes.despesaVendaItem;
    this.freteVendaItem = configuracoes.freteVendaItem;
    this.zerarSaldoAnteriorCaixa = configuracoes.zerarSaldoAnteriorCaixa;
    this.utilizarSuprimentoSangria = configuracoes.utilizarSuprimentoSangria;
    this.exibirDescricaoServico = configuracoes.exibirDescricaoServico;
    this.buscaProdutosCodigoBarras = configuracoes.buscaProdutosCodigoBarras;
    this.inicialCodigoBarrasBalanca = parseInt(
      configuracoes.inicialCodigoBarrasBalanca,
    );
    this.leituraPadraoBalanca = configuracoes.leituraPadraoBalanca;
    this.impressoraEtiqueta = configuracoes.impressoraEtiqueta;
    this.impressoraTermica = configuracoes.impressoraTermica;
    this.impressaoDiretaOrcamentos = configuracoes.impressaoDiretaOrcamentos;
    this.impressaoDiretaPedidos = configuracoes.impressaoDiretaPedidos;
    this.impressaoDiretaNf = configuracoes.impressaoDiretaNf;
    this.modeloImpressaoPadraoNf = configuracoes.modeloImpressaoPadraoNf;
    this.lembreteAntecedenciaServico =
      configuracoes.lembreteAntecedenciaServico;
    this.modeloImpressaoPadraoCondicionais =
      configuracoes.modeloImpressaoPadraoCondicionais;
    this.modeloImpressaoPadraoOrcamentos =
      configuracoes.modeloImpressaoPadraoOrcamentos;
    this.modeloImpressaoPadraoPedidos =
      configuracoes.modeloImpressaoPadraoPedidos;
    this.confirmacaoImpressaoOrcamentos =
      configuracoes.confirmacaoImpressaoOrcamentos;
    this.confirmacaoImpressaoPedidos =
      configuracoes.confirmacaoImpressaoPedidos;
    this.confirmacaoImpressaoNf = configuracoes.confirmacaoImpressaoNf;
    this.confirmacaoImpressaoPdv = configuracoes.confirmacaoImpressaoPdv;
    this.vendedorPorItemServico = configuracoes.vendedorPorItemServico;
  }

  setPagamentosPadroes(listaPagamentoPadrao) {
    if (listaPagamentoPadrao?.length) {
      this.pagamentosPadroes = listaPagamentoPadrao.map((item) => item.id);
    }
  }
}
